import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConditionsRules } from './configs';
import { RulesDynamicFormService } from '@app/sharedModule/components/rules-dynamic-form/rules-dynamic-form.service';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';

@Component({
  selector: 'product-page-conditions',
  templateUrl: './product-page-conditions.component.html',
  standalone: false,
})
export class ProductPageConditionsComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  readonly formArrayFieldName = 'conditionsRules';
  entities;
  conditionsRules = [...ConditionsRules];

  constructor(private rulesDynamicFormService: RulesDynamicFormService) {}

  ngOnInit() {
    this.entities = this.conditionsRules.map((b) => b.entity);
  }

  get shopPrimaryLocation() {
    const primaryL = this.shop.shopLocations.find((l) => l.isPrimaryLocation) ?? this.shop.shopLocations[0];
    return primaryL;
  }
}
